export function getInitialFormDataModel(blocks) {
  const formDataModel = {};
  blocks.forEach(item => {
    let value = '';
    if (item.block.type === 'cards' || item.block.type === 'interactiveTable') {
      value = {};
      for (const [cardKey] of Object.entries(item.block.fields.cards)) {
        value[cardKey] = {};
        for (const [fieldKey] of Object.entries(item.block.fields.cardFields)) {
          value[cardKey][fieldKey] = '';
        }
      }
    }
    if (item.block.type === 'dropdown') {
      value = {
        value: '',
        images: item.block.fields.choicesType === 'checkbox' ? [] : ''
      };
    }
    if (item.block.type === 'imagesChoice' || item.block.type === 'multipleChoiceQuestion') {
      value = item.block.fields.choicesType === 'checkbox' ? [] : '';
    }
    formDataModel[item.id] = value;
  });
  return formDataModel;
}
